import styled from 'styled-components';

export default styled.div`
  text-align: center;
  display: grid;
  grid-template-rows: auto 1fr;
  grid-row-gap: 0.5rem;
  margin-top: 2rem;

  em {
    font-style: normal;
    font-weight: 500;
  }
`;
